/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowApiControllersPlanningMeTimeClockControllerConfirmDayRequestDto,
  FacilityFlowApiControllersPlanningMeTimeClockControllerRecordEventRequestDto,
  FacilityFlowApiControllersPlanningMeTimeClockControllerSelfCorrectRequestDto,
  FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto,
  FacilityFlowCoreModulesPlanningWorkflowsTimeClockStampingWindowDto,
  FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto,
  GetApiV1MeTimeclockHistoryParams,
  GetApiV1MeTimeclockOvertimeBalanceParams,
  GetApiV1MeTimeclockParams,
  GetApiV1MeTimeclockWindowParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getMeTimeClock = () => {
/**
 * @summary Get time clock status for a specific date (or today)
 */
const getApiV1MeTimeclock = (
    params?: GetApiV1MeTimeclockParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto | void>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto | void>(
      {url: `/api/v1/me/timeclock`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary The own clock-in window for a date (or the tenant's local today): the season of the own
time clock group, or the tenant policy (groupId/groupName null). ADR-0025.
 */
const getApiV1MeTimeclockWindow = (
    params?: GetApiV1MeTimeclockWindowParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockStampingWindowDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockStampingWindowDto>(
      {url: `/api/v1/me/timeclock/window`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Record a time clock event (ClockIn, ClockOut, BreakStart, BreakEnd)
 */
const postApiV1MeTimeclockEvent = (
    facilityFlowApiControllersPlanningMeTimeClockControllerRecordEventRequestDto: FacilityFlowApiControllersPlanningMeTimeClockControllerRecordEventRequestDto,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto>(
      {url: `/api/v1/me/timeclock/event`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowApiControllersPlanningMeTimeClockControllerRecordEventRequestDto
    },
      options);
    }
  /**
 * @summary Confirm a time clock day (employee confirms their own times)
 */
const postApiV1MeTimeclockConfirm = (
    facilityFlowApiControllersPlanningMeTimeClockControllerConfirmDayRequestDto: FacilityFlowApiControllersPlanningMeTimeClockControllerConfirmDayRequestDto,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto>(
      {url: `/api/v1/me/timeclock/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowApiControllersPlanningMeTimeClockControllerConfirmDayRequestDto
    },
      options);
    }
  /**
 * @summary Correct own time clock day (only allowed for unconfirmed days)
 */
const postApiV1MeTimeclockCorrect = (
    facilityFlowApiControllersPlanningMeTimeClockControllerSelfCorrectRequestDto: FacilityFlowApiControllersPlanningMeTimeClockControllerSelfCorrectRequestDto,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto>(
      {url: `/api/v1/me/timeclock/correct`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowApiControllersPlanningMeTimeClockControllerSelfCorrectRequestDto
    },
      options);
    }
  /**
 * @summary Get time clock history (Open / ThisWeek / ThisMonth / LastMonth)
 */
const getApiV1MeTimeclockHistory = (
    params?: GetApiV1MeTimeclockHistoryParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockDayDto[]>(
      {url: `/api/v1/me/timeclock/history`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Das eigene Überstundenkonto bis zum Ende des Monats, der referenceMonth
enthält (ohne Angabe: der laufende Monat). Enthält die Monatsaufstellung und das
Korrektur-Protokoll (ADR-0015).
 */
const getApiV1MeTimeclockOvertimeBalance = (
    params?: GetApiV1MeTimeclockOvertimeBalanceParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto>(
      {url: `/api/v1/me/timeclock/overtime-balance`, method: 'GET',
        params
    },
      options);
    }
  return {getApiV1MeTimeclock,getApiV1MeTimeclockWindow,postApiV1MeTimeclockEvent,postApiV1MeTimeclockConfirm,postApiV1MeTimeclockCorrect,getApiV1MeTimeclockHistory,getApiV1MeTimeclockOvertimeBalance}};
export type GetApiV1MeTimeclockResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTimeClock>['getApiV1MeTimeclock']>>>
export type GetApiV1MeTimeclockWindowResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTimeClock>['getApiV1MeTimeclockWindow']>>>
export type PostApiV1MeTimeclockEventResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTimeClock>['postApiV1MeTimeclockEvent']>>>
export type PostApiV1MeTimeclockConfirmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTimeClock>['postApiV1MeTimeclockConfirm']>>>
export type PostApiV1MeTimeclockCorrectResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTimeClock>['postApiV1MeTimeclockCorrect']>>>
export type GetApiV1MeTimeclockHistoryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTimeClock>['getApiV1MeTimeclockHistory']>>>
export type GetApiV1MeTimeclockOvertimeBalanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeTimeClock>['getApiV1MeTimeclockOvertimeBalance']>>>
